module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTYgOCI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTUuODczLjczNywxNS4xNTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEw4LDUuODIsMS40NTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEwuMTI3LjczN2EuMzQ3LjM0NywwLDAsMCwwLC41MzdMNy42OTMsNy44ODlhLjQ3OS40NzksMCwwLDAsLjYxNCwwbDcuNTY2LTYuNjE1QS4zNDcuMzQ3LDAsMCwwLDE1Ljg3My43MzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNiA4KSByb3RhdGUoMTgwKSIgZmlsbD0iIzAwMzY3OSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/config-filter-display-icon.svg
// module id = 1OSr
// module chunks = 26